/*
 *
 * ProductTour constants
 *
 */

import upi from 'images/upi.svg';
import cards from 'images/cards.svg';
import netbanking from 'images/netbanking.svg';
import paylater from 'images/paylater.svg';
import wallets from 'images/wallets.svg';
import internationalPayments from 'images/international-payments.svg';

import disabledUpi from 'images/disabled-upi.svg';
import disabledCards from 'images/disabled-cards.svg';
import disabledNetBanking from 'images/disabled-netbanking.svg';
import disabledPaylater from 'images/disabled-paylater.svg';
import disabledWallets from 'images/disabled-wallets.svg';
import disabledInternationalPayments from 'images/disabled-international-payments.svg';

import { WHITELISTING_STATUS } from './type';

export const BASE_ACTION_CONSTANT = 'app/ProductTour';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const GET_WHITELISTING_DATA = `${BASE_ACTION_CONSTANT}/GET_WHITELISTING_DATA`;

export const GET_PAYMENT_GROUPS_DATA = `${BASE_ACTION_CONSTANT}/GET_PAYMENT_GROUPS_DATA`;

export const GET_MERCHANT_PROFILE_DATA = `${BASE_ACTION_CONSTANT}/GET_MERCHANT_PROFILE_DATA`;

export const GET_INSTALLED_APPS_DATA = `${BASE_ACTION_CONSTANT}/GET_INSTALLED_APPS_DATA`;

export const UPDATE_DAY_ZERO_STATUS = 'UPDATE_DAY_ZERO_STATUS';

export const TRIGGER_DAY_ZERO_SHOPIFY_MODAL = 'TRIGGER_DAY_ZERO_SHOPIFY_MODAL';

export const SHOW_PROFILE_ACTIVATION_SCREEN = 'SHOW_PROFILE_ACTIVATION_SCREEN';

export const ONE_CASHFREE_PAYMENTS_APP = 'ONE_CASHFREE_PAYMENTS_APP';

export const DAY_ZERO_SHOPIFY_MODAL_CHECK_LIST_ID = 7069;

export const DOMAIN_REF = 'domain_name';

export const PACKAGE_REF = 'android_package';

export const CHECK_LIST_ELIGIBLE_STATUS = {
  ELIGIBLE: 'eligible',
  NOT_ELIGIBLE: 'not_eligible',
  DISPOSED: 'disposed',
};

export const CHECK_LIST_STATUS = {
  DONE: 'done',
  OPEN: 'open',
  TBD: 'tbd',
  FINISHED: 'finished',
};

export const DAY_ZERO_CHECKLIST_ITEM = {
  SHOPIFY_DONE: 'DAY_ZERO_SHOPIFY_DONE',
  SHOPIFY_RESUME: 'DAY_ZERO_SHOPIFY_RESUME',
  SHOPIFY_COMPLETED: 'DAY_ZERO_SHOPIFY_COMPLETED',
  PROFILE_PROMPT: 'DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION_PROMPT_COMPLETED',
  PROFILE_DOMAIN_AND_PAYMENT_MOTHOD_CONFIRMED:
    'DAY_ZERO_SHOPIFY_PROFILE_DOMAIN_AND_PAYMENT_MOTHOD_CONFIRMED',
  PROFILE_ACTIVATION_VIDEO_WATCHED:
    'DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION_VIDEO_WATCHED',
  PROFILE_ACTIVATION_COMPLETED: 'DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION_COMPLETED',
};

export const DAY_ZERO_EVENTS = {
  // Modal checklist events
  MODAL_CHECKLIST_STARTED: 'SHOPIFY_MODAL_CHECKLIST_STARTED',
  MODAL_CHECKLIST_DONE: 'SHOPIFY_MODAL_CHECKLIST_DONE',
  MODAL_CHECKLIST_RESUME: 'SHOPIFY_MODAL_CHECKLIST_RESUME',
  MODAL_CHECKBOX_CLICKED: 'SHOPIFY_MODAL_CHECKBOX_CLICKED',
  MODAL_THUMBNAIL_CLICKED: 'SHOPIFY_MODAL_THUMBNAIL_CLICKED',
  MODAL_LEARN_MORE_CLICKED: 'SHOPIFY_MODAL_LEARN_MORE_CLICKED',

  // Profile Activation checklist events
  PROFILE_CASHFREE_ACTIVATED_START: 'PROFILE_CASHFREE_ACTIVATED_START',
  PROFILE_CASHFREE_PROMPT_START: 'PROFILE_CASHFREE_PROMPT_START',
  PROFILE_CASHFREE_INSTALL_PLUGIN: 'PROFILE_CASHFREE_INSTALL_PLUGIN',
  PROFILE_DOMAIN_CHECK_CLICKED: 'PROFILE_DOMAIN_CHECK_CLICKED',
  PROFILE_PAYMENT_METHOD_SELECTED: 'PROFILE_PAYMENT_METHOD_SELECTED',
  PROFILE_DOMAIN_PAYMENT_COMPLETED: 'PROFILE_DOMAIN_PAYMENT_COMPLETED',
  PROFILE_MARK_AS_DONE_CLICKED: 'PROFILE_MARK_AS_DONE_CLICKED',
  PROFILE_DASHBOARD_NAVIGATION: 'PROFILE_DASHBOARD_NAVIGATION',
  PROFILE_SHOW_ME_HOW: 'PROFILE_SHOW_ME_HOW',
  PROFILE_REACH_OUT: 'PROFILE_REACH_OUT',
};

export const DAY_ZERO_PROFILE_ACTIVATION_STEP = {
  INITIAL_SCREEN: 'INITIAL_SCREEN',
  VERIFY_SCREEN: 'VERIFY_SCREEN',
  FINAL_SCREEN: 'FINAL_SCREEN',
};

export const UPDATE_USER_ON_PRODUCT_FRUIT = 'UPDATE_USER_ON_PRODUCT_FRUIT';

export const PAYMENT_METHOD_GROUPS = [
  {
    name: 'UPI',
    methods: ['UPI', 'UPI_PPI', 'UPI_CREDIT_CARD'],
    enabledIcon: upi,
    disabledIcon: disabledUpi,
    enabled: false,
    order: 1,
  },
  {
    name: 'Cards',
    methods: ['CREDIT_CARD', 'DEBIT_CARD', 'PREPAID_CARD'],
    enabledIcon: cards,
    disabledIcon: disabledCards,
    enabled: true,
    order: 2,
  },
  {
    name: 'Net banking',
    methods: ['NET_BANKING'],
    enabledIcon: netbanking,
    disabledIcon: disabledNetBanking,
    enabled: false,
    order: 3,
  },
  {
    name: 'Pay Later',
    methods: ['PAY_LATER', 'CREDIT_CARD_EMI', 'DEBIT_CARD_EMI'],
    enabledIcon: paylater,
    disabledIcon: disabledPaylater,
    enabled: false,
    order: 4,
  },
  {
    name: 'Wallets',
    methods: ['Wallet'],
    enabledIcon: wallets,
    disabledIcon: disabledWallets,
    enabled: false,
    order: 5,
  },
  {
    name: 'International Payments',
    methods: ['IPG', 'PAYPAL'],
    enabledIcon: internationalPayments,
    disabledIcon: disabledInternationalPayments,
    enabled: false,
    order: 6,
  },
];

export const MODAL_NAMES = {
  SHOPIFY_VIDEO: 'shopify-video',
  PAYMENT_METHODS: 'payment-methods',
  YOUR_DOMAIN: 'your-domain',
};

export const EMBED_LINKS = {
  CREATE_FIRST_ORDER: 'https://www.youtube.com/embed/mG6YK5_GLWk',
  ACTIVATE_ON_SHOPIFY: 'https://www.youtube.com/embed/wj7o_vGqQLA',
  DAY_ZERO_SHOPIFY_URL: 'https://www.youtube.com/embed/9k1ub5HSwHM',
  API_INTEGRATION_WEB: 'https://www.youtube.com/embed/T2-u92DetqU',
  API_INTEGRATION_MOBILE_ANDROID: 'https://youtube.com/embed/oqsw2qUFWYw',
  API_INTEGRATION_MOBILE_IOS: 'https://youtube/.com/embed/J1fIqjgiMeY',
  API_INTEGRATION_MOBILE_HYBRID_FLUTTER:
    'https://youtube.com/embed/J1fIqjgiMeY',
  API_INTEGRATION_MOBILE_HYBRID_REACTNATIVE: '',
  API_INTEGRATION_MOBILE_HYBRID_CORDOVA: '',
};

export const STEP_NUMBER_STATUS_COLOR = {
  success: 'primary',
  inProgress: 'primary',
};

export const REJECTION_STATUSES: string[] = [
  WHITELISTING_STATUS.REJECTED,
  WHITELISTING_STATUS.ACTION_PENDING,
];

export const ACTIVATE_SHOPIFY_LINK =
  'https://admin.shopify.com/settings/payments/third-party-providers/33390593';

export const APP_STATES = {
  CASHFREE: 'CASHFREE',
  CARD: 'CARD',
  NO_METHOD: 'NO_METHOD',
};
